export const CURRENCY_MAP: Record<string, string> = {
    Euro: 'EUR',
};

/**
 * Normalize backend currency strings to ISO codes for formatting.
 * Falls back to 'XXX' (ISO code for no currency) to avoid runtime errors.
 */
export function normalizeCurrency(code: string | null | undefined): string {
    if (!code) return 'XXX';

    const mapped = CURRENCY_MAP[code];
    if (mapped) return mapped;

    const upper = code.toUpperCase();
    if (/^[A-Z]{3}$/.test(upper)) return upper;

    console.warn('[currency] Unknown currency code, fallback to XXX:', code);
    return 'XXX';
}
